import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  deleteToken,
  onMessage,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDHr7tEyiYNPYAZMLw8w-Vta7YX19B82hs",
  authDomain: "one-site-cart-dev.firebaseapp.com",
  projectId: "one-site-cart-dev",
  storageBucket: "one-site-cart-dev.firebasestorage.app",
  messagingSenderId: "364179192296",
  appId: "1:364179192296:web:33f919ff16815c1add8c5d",
};

const VAPID_KEY =
  "BHaTtGarAnJ3o9I0oLwOzyhx3eXl2NBQ8EL40G-XvSi5staPyd0dI_dmeTXIwsHJq0T__2Yw6vM2M8Ml6gn_o-Q";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, deleteToken, onMessage, VAPID_KEY };